/* BLU · Rastreie seu pedido
   Rastreio pela Olist via Worker da Cloudflare (blu-rastreio), que repassa envios-api.olist.com. */
(function () {
  'use strict';
  var OLIST = 'https://envios.olist.com/rastreios/';
  var SRC = 'https://www.17track.net/externalcall.js';
  var T17 = 'https://t.17track.net/pt#nums=';
  var CORREIOS = 'https://rastreamento.correios.com.br/app/index.php';
  var LOAD_MS = 12000;   // tempo máximo para o script da 17TRACK chegar
  var FRAME_MS = 9000;   // tempo máximo para o widget montar o resultado
  var RE_CORREIOS = /^[A-Z]{2}\d{9}[A-Z]{2}$/;

  var lib = { st: 0, q: [] }; // 0 nada, 1 carregando, 2 pronto, 3 falhou

  function libOk() {
    return !!(window.YQV5 && typeof window.YQV5.trackSingle === 'function');
  }

  function loadLib(cb) {
    if (libOk()) { lib.st = 2; return cb(true); }
    if (lib.st === 1) { lib.q.push(cb); return; }
    lib.st = 1; lib.q = [cb];
    var done = false, s = document.createElement('script');
    function end(ok) {
      if (done) return;
      done = true; clearTimeout(t);
      ok = ok && libOk();
      lib.st = ok ? 2 : 3;
      if (!ok && s.parentNode) s.parentNode.removeChild(s);
      var q = lib.q; lib.q = [];
      q.forEach(function (f) { f(ok); });
    }
    var t = setTimeout(function () { end(false); }, LOAD_MS);
    s.src = SRC; s.async = true;
    s.onload = function () { end(true); };
    s.onerror = function () { end(false); };
    document.head.appendChild(s);
  }

  function clean(v) {
    return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 40);
  }

  function esc(v) {
    return String(v).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function copy(txt) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(txt).then(function () { return true; }, function () { return false; });
    } catch (e) {}
    return Promise.resolve(false);
  }

  function setUrl(code) {
    try {
      var u = new URL(location.href);
      if (code) u.searchParams.set('codigo', code); else u.searchParams.delete('codigo');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  var n = 0;

  function init(root) {
    if (root.__brt) return;
    root.__brt = 1;
    var uid = 'brt-yq-' + (++n);
    var form = root.querySelector('[data-form]');
    var input = form.querySelector('input');
    var btn = form.querySelector('button[type=submit]');
    var msg = root.querySelector('[data-msg]');
    var out = root.querySelector('[data-out]');
    var wa = root.querySelector('[data-wa]');
    var waBase = wa ? wa.getAttribute('href').split('?')[0] : '';
    var mob = window.matchMedia('(max-width: 767px)');
    var run = 0, current = '';
    var sub = root.querySelector('.brt-sub');
    if (sub) sub.textContent = 'Cole o código e veja aqui mesmo cada etapa da entrega da sua BLU.';

    /* pote espiando no canto (decorativo, depois do primeiro paint) */
    var pote = root.getAttribute('data-pote');
    if (pote) {
      var im = new Image();
      im.className = 'brt-pote'; im.alt = ''; im.width = 500; im.height = 943;
      im.decoding = 'async'; im.setAttribute('aria-hidden', 'true');
      im.onload = function () { im.classList.add('is-on'); };
      im.src = pote;
      root.querySelector('.brt-card').insertBefore(im, root.querySelector('.brt-card').firstChild);
    }

    function setWa(code) {
      if (!wa || !waBase) return;
      var t = 'Olá, BLU! Quero ajuda com o meu pedido' + (code ? ' (código de rastreio ' + code + ')' : '') + '.';
      wa.href = waBase + '?text=' + encodeURIComponent(t);
    }
    setWa('');

    function say(t) {
      msg.textContent = t || '';
      if (t) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }

    /* maiúsculas e sem espaços enquanto digita ou cola, sem pular o cursor */
    input.addEventListener('input', function () {
      var v = input.value, pos = input.selectionStart == null ? v.length : input.selectionStart;
      var c = v.toUpperCase().replace(/[^A-Z0-9]/gi, '');
      if (c !== v) {
        var before = v.slice(0, pos).toUpperCase().replace(/[^A-Z0-9]/gi, '').length;
        input.value = c;
        try { input.setSelectionRange(before, before); } catch (e) {}
      }
      if (msg.textContent) say('');
    });

    function head(code) {
      var tag = RE_CORREIOS.test(code) ? '<span class="brt-tag">Correios</span>' : '';
      return '<div class="brt-hd"><div class="brt-cd"><small>Código</small><b>' + esc(code) + '</b>' + tag + '</div>' +
        '<div class="brt-acts"><button type="button" class="brt-sm" data-copy>Copiar</button><button type="button" class="brt-sm" data-edit>Trocar</button></div></div>';
    }

    function fail(code) {
      var isC = RE_CORREIOS.test(code);
      var a17 = '<a class="is-' + (isC ? 2 : 1) + '" href="' + T17 + encodeURIComponent(code) + '" target="_blank" rel="noopener">Rastrear na 17TRACK</a>';
      var aC = '<a class="is-' + (isC ? 1 : 2) + '" href="' + CORREIOS + '" target="_blank" rel="noopener" data-cor>Rastrear nos Correios</a>';
      out.innerHTML = head(code) +
        '<div class="brt-er" role="alert"><h3>Não conseguimos abrir o rastreio aqui agora.</h3>' +
        '<p>Às vezes a conexão oscila. Você vê o mesmo resultado direto no site de rastreio:</p>' +
        '<div class="brt-bt">' + (isC ? aC + a17 : a17 + aC) + '</div>' +
        '<p class="brt-nt" data-nt></p>' +
        '<button type="button" class="brt-ag" data-again>Tentar de novo aqui</button></div>';
      btn.removeAttribute('aria-busy');
    }

    var API = 'https://blu-rastreio.royal-wave-fdab.workers.dev/?codigo=';
    var STEPS = ['Em preparação', 'Coletado', 'Em trânsito', 'Saiu para entrega', 'Entregue'];

    function cap(t) { t = String(t || '').replace(/\s+/g, ' ').trim(); return t ? t.charAt(0).toUpperCase() + t.slice(1) : ''; }
    function lvl(e) {
      var st = e.status || '', ti = (e.title || '').toLowerCase();
      if (st === 'delivered' || /^entregue/.test(ti)) return 4;
      if (/saiu para entrega/.test(ti)) return 3;
      if (st === 'shipped') return 2;
      if (st === 'collected' || st === 'received') return 1;
      return 0;
    }
    function when(iso) {
      try {
        var d = new Date(iso);
        return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'America/Sao_Paulo' }) + ' às ' +
          d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });
      } catch (e) { return ''; }
    }
    function place(e) {
      var l = e.location || {}, p = [l.city, l.state].filter(Boolean).join(', ');
      if (!p && e.description) p = String(e.description).replace(/\s+-\s+/g, ', ');
      return p;
    }
    function olistBtn(url, txt) { return '<div class="brt-bt"><a class="is-2" href="' + url + '" target="_blank" rel="noopener">' + txt + '</a></div>'; }

    function render(code, v, url) {
      var ev = (v.events || []).slice().sort(function (a, b) { return new Date(b.datetime) - new Date(a.datetime); });
      var list = [], seen = {};
      ev.forEach(function (e) {
        var k = cap(e.title) + '|' + place(e);
        if (seen[k]) return; seen[k] = 1; list.push(e);
      });
      var now = list.length ? lvl(list[0]) : 0;
      list.forEach(function (e) { now = Math.max(now, lvl(e)); });
      var prev = v.delivery_detail && (v.delivery_detail.olist_promissed_date || v.delivery_detail.carrier_promissed_date);
      var prevTxt = '';
      if (prev && now < 4) { try { prevTxt = new Date(prev + 'T12:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }); } catch (e) {} }
      var steps = STEPS.map(function (t, k) {
        return '<li class="' + (k < now ? 'is-ok' : k === now ? 'is-on' : '') + '"><i></i><span>' + t + '</span></li>';
      }).join('');
      var items = list.map(function (e, k) {
        var p = place(e);
        return '<li' + (k === 0 ? ' class="is-top"' : '') + '><time>' + esc(when(e.datetime)) + '</time><b>' + esc(cap(e.title)) + '</b>' + (p ? '<span>' + esc(p) + '</span>' : '') + '</li>';
      }).join('');
      return '<div class="brt-st' + (now === 4 ? ' is-done' : '') + '">' +
        '<div class="brt-sth"><small>' + esc(v.carrier_name || 'Transportadora') + '</small><h3>' + STEPS[now] + '</h3>' +
        (prevTxt ? '<p>Previsão de entrega: <b>' + prevTxt + '</b></p>' : (now === 4 ? '<p>Seu pedido chegou. Aproveite a sua BLU!</p>' : '')) + '</div>' +
        '<ol class="brt-pg" aria-label="Etapas da entrega">' + steps + '</ol>' +
        (items ? '<h4 class="brt-tlh">Histórico</h4><ol class="brt-tl">' + items + '</ol>' : '') + '</div>' +
        '<p class="brt-ft">Dados da Olist, atualizados pela transportadora. <a href="' + url + '" target="_blank" rel="noopener">Ver na Olist</a></p>';
    }

    function track(code, scroll) {
      var my = ++run;
      current = code;
      setUrl(code); setWa(code);
      var url = OLIST + encodeURIComponent(code);
      btn.setAttribute('aria-busy', 'true');
      out.hidden = false;
      out.classList.remove('is-new'); void out.offsetWidth; out.classList.add('is-new');
      out.innerHTML = head(code) +
        '<div class="brt-fr" aria-busy="true"><div class="brt-ld" role="status"><div class="brt-rt" aria-hidden="true"><i></i><b></b><i></i></div>' +
        '<p>Buscando na transportadora</p><span>Leva só alguns segundos.</span>' +
        '<div class="brt-sk" aria-hidden="true"><i></i><i></i><i></i><i></i></div></div></div>';
      if (scroll) {
        var r = out.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.55 || r.top < 0) {
          try { out.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); } catch (e) { out.scrollIntoView(); }
        }
      }
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var tm = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
      fetch(API + encodeURIComponent(code), ctl ? { signal: ctl.signal } : {}).then(function (r) {
        if (r.status === 404) return [];
        if (!r.ok) throw new Error('http');
        return r.json();
      }).then(function (j) {
        clearTimeout(tm);
        if (my !== run) return;
        btn.removeAttribute('aria-busy');
        var v = Array.isArray(j) ? j[0] : null;
        if (!v || !v.events || !v.events.length) {
          out.innerHTML = head(code) + '<div class="brt-er brt-ol"><h3>Ainda não encontramos esse código.</h3>' +
            '<p>Ele aparece aqui algumas horas depois que a transportadora registra o envio. Confira se o código está completo ou tente de novo mais tarde.</p>' +
            olistBtn(url, 'Consultar na Olist') + '</div>';
          return;
        }
        out.innerHTML = head(code) + render(code, v, url);
      }).catch(function () {
        clearTimeout(tm);
        if (my !== run) return;
        btn.removeAttribute('aria-busy');
        out.innerHTML = head(code) + '<div class="brt-er brt-ol"><h3>Não conseguimos carregar o rastreio agora.</h3>' +
          '<p>Às vezes a conexão oscila. Você vê o mesmo resultado direto na Olist:</p>' +
          '<div class="brt-bt"><a class="is-1" href="' + url + '" target="_blank" rel="noopener">Ver onde está meu pedido</a></div>' +
          '<button type="button" class="brt-ag" data-again>Tentar de novo aqui</button></div>';
      });
    }

    function go(scroll) {
      var code = clean(input.value);
      input.value = code;
      if (!code) { say('Digite ou cole o código que chegou no seu WhatsApp ou e-mail.'); input.focus(); return; }
      if (code.length < 8) { say('Esse código parece incompleto. Confira se copiou ele inteiro.'); input.focus(); return; }
      say('');
      input.blur();
      track(code, scroll);
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); go(true); });

    out.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t) return;
      if (t.hasAttribute('data-edit')) {
        run++; out.hidden = true; out.innerHTML = ''; btn.removeAttribute('aria-busy');
        setUrl(''); setWa('');
        input.value = ''; input.focus();
        try { root.querySelector('.brt-card').scrollIntoView({ block: 'nearest' }); } catch (er) {}
      } else if (t.hasAttribute('data-again')) {
        track(current, false);
      } else if (t.hasAttribute('data-copy')) {
        copy(current).then(function (ok) {
          if (!ok) {
            try {
              var r = document.createRange(), sel = window.getSelection();
              r.selectNodeContents(out.querySelector('.brt-cd b'));
              sel.removeAllRanges(); sel.addRange(r);
              ok = document.execCommand('copy');
            } catch (er) {}
          }
          t.textContent = ok ? 'Copiado' : 'Selecionado';
          t.classList.toggle('is-ok', ok);
          setTimeout(function () { t.textContent = 'Copiar'; t.classList.remove('is-ok'); }, 1800);
        });
      } else if (t.hasAttribute('data-cor')) {
        var nt = out.querySelector('[data-nt]');
        copy(current).then(function (ok) {
          if (nt) nt.textContent = ok ? 'Copiamos o código. No site dos Correios, é só colar.' : 'No site dos Correios, digite o código ' + current + '.';
        });
      }
    });

    /* ?codigo=XXXX na URL já abre rastreando (links do WhatsApp e e-mail) */
    var q = '';
    try { q = clean(new URLSearchParams(location.search).get('codigo')); } catch (e) {}
    if (q) { input.value = q; if (q.length >= 8) track(q, mob.matches); else say('Esse código parece incompleto. Confira se copiou ele inteiro.'); }

    requestAnimationFrame(function () { root.classList.add('is-ready'); });
  }

  function boot() {
    var els = document.querySelectorAll('[data-blu-rastreio]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
